export default "/images/6c1fcd6cecd74ca448ed265c78691cd5.jpg";